import {gql} from "@irati/utils/gql"

import MarketingProfile from "../fragments/marketingProfile"

const query = gql`
  query GetMarketingProfile($data: GetMarketingProfileInput!) {
    marketingProfile(data: $data) {
      ...MarketingProfile
    }
  }
  ${MarketingProfile}
`

export default query
